<template>
    <div>
        <form>
            <form-input :placeholder="$t('COMMON.companyName')"
                        :elementID="'company'"
                        :containerClass="'form-group'"
                        :inputType="'text'"
                        :validator="$v.form.company"
                        v-model="form.company">
            </form-input>
    
            <form-input :placeholder="$t('COMPANYDATA.street')"
                        :elementID="'addressStreet'"
                        :containerClass="'form-group'"
                        :inputType="'text'"
                        :validator="$v.form.address.street"
                        v-model="form.address.street">
            </form-input>
            
            <form-input :placeholder="$t('COMPANYDATA.streetNumber')"
                        :elementID="'addressStreetNumber'"
                        :containerClass="'form-group'"
                        :inputType="'text'"
                        :validator="$v.form.address.streetNumber"
                        v-model="form.address.streetNumber">
            </form-input>
            
            <form-input :placeholder="$t('COMPANYDATA.postCode')"
                        :elementID="'addressPostCode'"
                        :containerClass="'form-group'"
                        :inputType="'text'"
                        :validator="$v.form.address.postCode"
                        v-model="form.address.postCode">
            </form-input>
    
            <form-input :placeholder="$t('COMPANYDATA.city')"
                        :elementID="'addressCity'"
                        :containerClass="'form-group'"
                        :inputType="'text'"
                        :validator="$v.form.address.city"
                        v-model="form.address.city">
            </form-input>
            
            <form-input :placeholder="$t('COMPANYDATA.taxId')"
                        :elementID="'USID'"
                        :containerClass="'form-group'"
                        :inputType="'text'"
                        :validator="$v.form.USID"
                        v-model="form.USID">
            </form-input>
            
            <div class="clearfix">
                <div class="btn-toolbar d-flex align-content-center float-sm-left m-t-1">
                    <button type="button" class="btn btn-cph-primary" name="save"
                            @click="save" :disabled="$v.form.$invalid">
                        {{$t('UI.save')}}
                    </button>
                    <span v-if="errorMessage" class="error-msg">
                        {{errorMessage}}
                    </span>
                </div>
            </div>
        </form>
    </div>
</template>

<script type="text/babel">
import { required, minLength, numeric, between } from 'vuelidate/lib/validators';
import { ustid } from '../../../../utilities/validators/ustid';
import {mapActions} from 'vuex';
import FormInput from '../../../Shared/UI/Form/FormInput.vue';
export default {
    name: 'CompanyDataForm',
    data () {
        return {
            errorMessage: '',
            form: {
                company: '',
                address: {
                    street: '',
                    streetNumber: '',
                    postCode: '',
                    city: ''
                },
                USID: ''
            }
        };
    },
    components: {
        FormInput
    },
    methods: {
        ...mapActions(['saveCompanyData', 'getCompanyData']),
        save () {
            this.saveCompanyData(this.form);
        },
        async init () {
            try {
                let {USID, address, company } = await this.getCompanyData();
                if(address) {
                    this.form = {
                        USID,
                        company,
                        address: {
                            street: address,
                            streetNumber: '',
                            postCode: '',
                            city: ''
                        }
                    };
                }
            } catch (err) {
                throw new Error(err);
            }
        }
    },
    created () {
        this.init();
    },
    validations: {
        form: {
            company: {
                required,
                minLength: minLength(4)
            },
            address: {
                street: {
                    required
                },
                streetNumber: {
                    required
                },
                postCode: {
                    required
                },
                city: {
                    required
                }
            },
            USID: {
                required,
                ustid
            }
        }
    }
};

</script>
